export const getSidebarNav = () => {
  return [
    {
      name: "Home",
      to: "/",
      fontIcon: "fa fa-home",
    },
    {
      name: "Counterparts",
      to: "/counterparts",
      fontIcon: "fa fa-users",
    },
    {
      name: "CRI Process",
      to: "/cri-process",
      fontIcon: "fa fa-tachometer",
    },
    {
      name: "Search ",
      to: "/search",
      fontIcon: "fa fa-search",
    },
    {
      name: "Violation Tracker",
      to: "/violation-tracker",
      fontIcon: "fa fa-bars",
    },
    {
      name: "Configuration",
      fontIcon: "fa fa-wrench",
      items: [
        {
          name: "Risk Factors",
          to: "/configuration/risk-factors",
          fontIcon: "fa fa-gear",
        },
        {
          name: "Blacklist TED",
          to: "/configuration/blacklist",
          fontIcon: "fa fa-table-cells",
        },
        {
          name: "Whitelist TED",
          to: "/configuration/whitelist",
          fontIcon: "fa fa-grip",
        },
      ],
    },
  ];
};
